/**
 *   Generated file. Do not edit
 */

import { SlaveServerRawConfig } from './models';
import { AbstractService, ServiceCallType } from '@iotize/tap';
import { TapRequestFrame } from '@iotize/tap/client/api';
import * as serviceConverters from './service-converters';
import { converters as commonConverters } from '@iotize/tap/service/core';

const allConverters = {
  ...commonConverters,
  ...serviceConverters,
};

export const SERVICE_CALLS = {
  getProtocolConfiguration: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/slave-server/protocol-configuration',
    path: '/1024//92',
    responseBodyDecoder: allConverters.slaveServerRawConfig,
  } as ServiceCallType<void, SlaveServerRawConfig>,

  postProtocolConfiguration: {
    method: TapRequestFrame.MethodType.POST,
    pathAlias: '/slave-server/protocol-configuration',
    path: '/1024//92',
    bodyEncoder: allConverters.slaveServerRawConfig,
  } as ServiceCallType<SlaveServerRawConfig, void>,

  putProtocolConfiguration: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/slave-server/protocol-configuration',
    path: '/1024//92',
    bodyEncoder: allConverters.slaveServerRawConfig,
  } as ServiceCallType<SlaveServerRawConfig, void>,
};
